import { useState } from "react";
import {
  Box,
  TextField,
  Button,
  Typography,
  Paper
} from "@mui/material";
import API from "../services/api";

export default function Register() {
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [discordId, setDiscordId] = useState("");
  const [riotId, setRiotId] = useState("");
  const [phone, setPhone] = useState("");

  const handleRegister = async () => {
    try {
      if (!username || !email || !password) {
        return alert("Usuario, email y contraseña son obligatorios");
      }

      await API.post("/auth/register", {
        username,
        email,
        password,
        discordId,
        riotId,
        phone
      });

      alert("Usuario registrado correctamente");
      window.location.href = "/login";

    } catch (err) {
      console.log(err);
      alert(err?.response?.data?.message || "Error en registro");
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: `
          radial-gradient(circle at 50% 0%, rgba(255,110,0,0.15), transparent 40%),
          linear-gradient(180deg, #141414 0%, #2a1208 100%)
        `
      }}
    >
      <Paper
        elevation={6}
        sx={{
          p: 4,
          width: 350,
          background: "rgba(20,20,20,0.9)",
          backdropFilter: "blur(10px)",
          border: "1px solid rgba(255,110,0,0.3)"
        }}
      >
        <Typography
          variant="h5"
          sx={{
            mb: 3,
            color: "#fff",
            textAlign: "center",
            textShadow: "0 0 10px rgba(255,110,0,0.7)"
          }}
        >
          Crear Cuenta
        </Typography>

        <TextField
          fullWidth
          label="Usuario"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          margin="normal"
          InputLabelProps={{ style: { color: "#aaa" } }}
          sx={{
            input: { color: "#fff" },
            "& .MuiOutlinedInput-root": {
              "& fieldset": { borderColor: "#ff6e00" },
              "&:hover fieldset": { borderColor: "#ffae00" }
            }
          }}
        />

        <TextField
          fullWidth
          label="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          margin="normal"
          InputLabelProps={{ style: { color: "#aaa" } }}
          sx={{
            input: { color: "#fff" },
            "& .MuiOutlinedInput-root": {
              "& fieldset": { borderColor: "#ff6e00" },
              "&:hover fieldset": { borderColor: "#ffae00" }
            }
          }}
        />

        <TextField
          fullWidth
          label="Contraseña"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          margin="normal"
          InputLabelProps={{ style: { color: "#aaa" } }}
          sx={{
            input: { color: "#fff" },
            "& .MuiOutlinedInput-root": {
              "& fieldset": { borderColor: "#ff6e00" },
              "&:hover fieldset": { borderColor: "#ffae00" }
            }
          }}
        />

        <TextField
          fullWidth
          label="Discord ID (opcional)"
          value={discordId}
          onChange={(e) => setDiscordId(e.target.value)}
          margin="normal"
          InputLabelProps={{ style: { color: "#aaa" } }}
          sx={{
            input: { color: "#fff" },
            "& .MuiOutlinedInput-root": {
              "& fieldset": { borderColor: "#ff6e00" }
            }
          }}
        />

        <TextField
          fullWidth
          label="Riot ID (opcional)"
          value={riotId}
          onChange={(e) => setRiotId(e.target.value)}
          margin="normal"
          InputLabelProps={{ style: { color: "#aaa" } }}
          sx={{
            input: { color: "#fff" },
            "& .MuiOutlinedInput-root": {
              "& fieldset": { borderColor: "#ff6e00" }
            }
          }}
        />

        <TextField
          fullWidth
          label="Teléfono (opcional)"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          margin="normal"
          InputLabelProps={{ style: { color: "#aaa" } }}
          sx={{
            input: { color: "#fff" },
            "& .MuiOutlinedInput-root": {
              "& fieldset": { borderColor: "#ff6e00" }
            }
          }}
        />

        <Button
          fullWidth
          onClick={handleRegister}
          sx={{
            mt: 2,
            py: 1.5,
            fontWeight: "bold",
            background: "linear-gradient(90deg, #ff6e00, #ffae00)",
            color: "#000",
            boxShadow: "0 0 10px rgba(255,110,0,0.6)",
            "&:hover": {
              background: "linear-gradient(90deg, #ffae00, #ff6e00)"
            }
          }}
        >
          Registrarse
        </Button>
      </Paper>
    </Box>
  );
}